// src/auth.js
// Login com Google via Firebase Auth
// Cria perfil do usuário no Firestore na primeira entrada

import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore'
import { auth, provider, db } from './firebase.js'

// ── LOGIN ──────────────────────────────────────────────────────────────────
export async function loginWithGoogle() {
  try {
    const result = await signInWithPopup(auth, provider)
    if (result?.user) {
      await ensureUserProfile(result.user)
    }
  } catch (e) {
    // popup bloqueado, fechado pelo usuário, ou erro de rede
    const code = e?.code || ''
    if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') {
      // Usuário fechou o popup — não é erro real, ignora silenciosamente
      return
    }
    console.error('Erro no login:', e)
    throw e  // re-throw para que o chamador possa tratar
  }
}

// ── LOGOUT ─────────────────────────────────────────────────────────────────
export function logout() {
  return signOut(auth)
}

// ── OBSERVER: detecta mudança de estado de autenticação ───────────────────
// callback(user) — user é null se não logado
export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback)
}

// ── PERFIL DO USUÁRIO ──────────────────────────────────────────────────────
// Cria o documento do usuário no Firestore se for a primeira vez
// Role padrão: 'student' — mude para 'teacher' manualmente no Firebase Console
// ou implemente uma lógica de convite futuramente
export async function ensureProfile(user) {
  return ensureUserProfile(user)
}

async function ensureUserProfile(user) {
  const ref = doc(db, 'users', user.uid)
  const snap = await getDoc(ref)

  if (!snap.exists()) {
    await setDoc(ref, {
      uid:       user.uid,
      name:      user.displayName,
      email:     user.email,
      photoURL:  user.photoURL,
      role:      'student',           // 'student' | 'teacher'
      xp:        0,
      badges:    [],
      createdAt: serverTimestamp(),
      lastLogin: serverTimestamp(),
    })
  } else {
    // Atualiza último login
    await setDoc(ref, { lastLogin: serverTimestamp() }, { merge: true })
  }
}

// ── BUSCA PERFIL ───────────────────────────────────────────────────────────
export async function getUserProfile(uid) {
  const snap = await getDoc(doc(db, 'users', uid))
  return snap.exists() ? snap.data() : null
}
